module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.$store.state.is_auth) ? _c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.errorCode === 404) ? _c('notFoundPage') : (_vm.errorCode === 403) ? _c('div', {
    staticClass: "alert alert-danger text-center error-block",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/access_denied')))])]) : _c('div', {
    staticClass: "alert alert-danger text-center error-block",
    class: {
      'outer': !_vm.$store.state.is_auth
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.Text)),
      expression: "localeFtc(Text)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09445685"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/error500.vue
// module id = 721
// module chunks = 0